__webpack_require__.p = "/manipal-cigna-sarvah/";